import React, { useState, useRef, useEffect } from 'react';

const AIRLINES = [
  'SAS', 'Norwegian', 'Ryanair', 'Widerøe',
  'Lufthansa', 'British Airways', 'Air France', 'KLM',
  'easyJet', 'Wizz Air', 'Transavia', 'Finnair',
  'TAP Air Portugal', 'Air Serbia', 'Iberia', 'Turkish Airlines',
];

function AirlineSelect({ value, onChange, disabled }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selected = value ? value.split(', ').filter(Boolean) : [];

  const toggle = (airline) => {
    const next = selected.includes(airline)
      ? selected.filter(a => a !== airline)
      : [...selected, airline];
    onChange(next.join(', '));
  };

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="airline-select" ref={containerRef}>
      <button
        type="button"
        className={`airline-select-trigger ${open ? 'open' : ''}`}
        onClick={() => !disabled && setOpen(o => !o)}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {selected.length === 0 ? (
          <span className="airline-placeholder">Select airlines (optional)</span>
        ) : (
          <span className="airline-chips">
            {selected.map(a => (
              <span key={a} className="airline-chip">{a}</span>
            ))}
          </span>
        )}
        <span className="airline-select-arrow">{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div className="airline-dropdown" role="listbox" aria-multiselectable="true">
          {AIRLINES.map(airline => {
            const active = selected.includes(airline);
            return (
              <button
                key={airline}
                type="button"
                role="option"
                aria-selected={active}
                className={`airline-option ${active ? 'active' : ''}`}
                onClick={() => toggle(airline)}
              >
                {active ? '✓ ' : ''}{airline}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AirlineSelect;
